export default __webpack_public_path__ + "static/ex-logo-327f7f00e7fd30b809141ddad0abc6d2.png";